/* GG Hobby — instant sell-value estimator
   Seller builds a list from the real catalog (or custom items), enters TCGplayer market
   value per item, sees an instant payout estimate at up to 85% of market, and one click
   prefills the booking form with the whole list. Honest by design: the user supplies the
   market number (with a TCGplayer lookup link); the figure is labeled an estimate and the
   final offer happens at the appointment.
   Also: imports a TCGplayer collection/seller CSV (client-side only — the file never leaves
   the browser), and appends brand-new products the POS pushes to the live price feed, so a
   product added to the POS today shows up here without a theme redeploy. */
(function () {
  "use strict";

  var I18N = window.GG_I18N || {};
  function tr(s) { return I18N[s] || s; }

  var box = document.getElementById("estimator");
  if (!box) return;

  var select = document.getElementById("estSelect");
  var qtyInput = document.getElementById("estQty");
  var addBtn = document.getElementById("estAdd");
  var list = document.getElementById("estList");
  var figure = document.getElementById("estFigure");
  var marketFigure = document.getElementById("estMarket");
  var bookBtn = document.getElementById("estBook");

  // buy rate by product line: 85% on sealed Pokemon, 80% on One Piece
  function rateOf(p) { return (p && p.g === "op") ? 0.8 : 0.85; }
  var OP_NAME = /one ?piece|romance dawn|paramount war|\bop-?\d/i;

  var rows = [];

  // items GG does NOT buy — excluded from the picker entirely (safety net; the build filters too)
  var NO_BUY_TYPE = /^(booster box|booster pack|blister|3-pack blister|18 packer|slab|rip-to-hit|prize pack)$/i;
  var NO_BUY_NAME = /booster box|booster pack|\bblisters?\b|\bdisplay\b|18[ .-]?pack|halloween|trick.?or.?tr(eat|ade)|prismatic evolutions booster bundle|\bslab\b|graded|damaged|prize pack|rip.?to.?hit|tech[ .-]?stickers?/i;
  // ONE PIECE exception (Aug 2026): single/loose booster packs and blisters of
  // One Piece ARE bought (at the 80% rate) — the pack/blister patterns come off
  // the block list for OP only. Boxes, displays, slabs, damaged etc. stay blocked.
  var NO_BUY_TYPE_OP = /^(booster box|18 packer|slab|rip-to-hit|prize pack)$/i;
  var NO_BUY_NAME_OP = /booster box|\bdisplay\b|18[ .-]?pack|halloween|trick.?or.?tr(eat|ade)|prismatic evolutions booster bundle|\bslab\b|graded|damaged|prize pack|rip.?to.?hit|tech[ .-]?stickers?/i;
  function isNoBuy(name, type, game) {
    var op = game === "op" || /one ?piece/i.test(String(game || "")) || OP_NAME.test(String(name || ""));
    if (op) return NO_BUY_TYPE_OP.test(type || "") || NO_BUY_NAME_OP.test(name || "");
    return NO_BUY_TYPE.test(type || "") || NO_BUY_NAME.test(name || "");
  }

  // rough display category from a product name (for items that arrive without one)
  function catOf(n) {
    if (/elite trainer box|\betb\b/i.test(n)) return "ETB";
    if (/booster bundle/i.test(n)) return "Booster Bundle";
    if (/build ?& ?battle/i.test(n)) return "Build & Battle";
    if (/\btin\b/i.test(n)) return "Tin";
    if (/\bdeck\b/i.test(n)) return "Deck";
    if (/collection|premium|binder|poster|\bpin\b/i.test(n)) return "Collection";
    if (/\bbox\b/i.test(n)) return "Box";
    return "Sealed";
  }

  // populate the product dropdown from the real catalog (buyable items only)
  var catalog = (window.GG_CATALOG || [])
    .filter(function (p) { return !isNoBuy(p.n, p.t, p.g); })
    .sort(function (a, b) { return a.n.localeCompare(b.n); });

  // TEMPORARY exclusions pushed live from the GG Hobby program (Worker /api/nobuy):
  // items we aren't taking right now but may take again — distinct from isNoBuy() above,
  // which is the permanent never-buy list. Fails soft: unreachable endpoint = empty list.
  var paused = [];            // [{label, sku, match}] — match is lowercase substring
  var pausedNote = "";
  function pausedHit(name, sku) {
    var n = String(name || "").toLowerCase(), s = String(sku || "").toLowerCase();
    for (var i = 0; i < paused.length; i++) {
      var x = paused[i];
      if ((x.sku && s && String(x.sku).toLowerCase() === s) ||
          (x.match && n.indexOf(x.match) !== -1)) return x;
    }
    return null;
  }

  var searchInput = document.getElementById("estSearch");

  /* ---- game filter chips (Aug 2026) ----
     One Piece booster packs are named "Romance Dawn Booster Pack" etc. — the words
     "one piece" never appear in the product name, so a NAME search can't surface
     them. The chips filter by GAME instead: tap "One Piece" and every OP item shows,
     whatever it's called. Built here in JS (not the HTML) so every page copy — the
     static site, the Spanish twin, the Shopify template — gets it with no markup edits. */
  var gameFilter = "all"; // "all" | "pk" | "op"
  function gameOf(p) { return (p.g === "op" || OP_NAME.test(p.n)) ? "op" : "pk"; }
  var GAME_CHIPS = [
    { key: "all", label: "All" },
    { key: "pk", label: "Pokémon" },
    { key: "op", label: "One Piece" },
  ];
  var chipWrap = null;
  function renderGameChips() {
    if (!chipWrap) {
      chipWrap = document.createElement("div");
      chipWrap.id = "estGameChips";
      chipWrap.setAttribute("role", "group");
      chipWrap.setAttribute("aria-label", tr("Filter by game"));
      chipWrap.style.cssText = "display:flex;gap:8px;flex-wrap:wrap;margin:0 0 10px";
      var add = box.querySelector(".estimator__add");
      if (add && add.parentNode) add.parentNode.insertBefore(chipWrap, add);
      else box.insertBefore(chipWrap, box.firstChild);
    }
    chipWrap.innerHTML = "";
    GAME_CHIPS.forEach(function (c) {
      var b = document.createElement("button");
      b.type = "button";
      b.textContent = tr(c.label);
      b.setAttribute("aria-pressed", gameFilter === c.key ? "true" : "false");
      b.style.cssText = "padding:6px 14px;border-radius:999px;font-size:13.5px;cursor:pointer;" +
        "border:1px solid " + (gameFilter === c.key ? "transparent" : "rgba(140,160,190,.4)") + ";" +
        (gameFilter === c.key
          ? "background:var(--accent,#1156f0);color:#fff;font-weight:bold"
          : "background:transparent;color:inherit");
      b.addEventListener("click", function () {
        gameFilter = c.key;
        renderGameChips();
        renderOptions(searchInput ? searchInput.value : "");
        syncLookup();
      });
      chipWrap.appendChild(b);
    });
  }

  function renderOptions(term) {
    term = (term || "").toLowerCase().trim();
    var terms = term.split(/\s+/).filter(Boolean);
    select.innerHTML = "";
    var shown = 0;
    catalog.forEach(function (p, i) {
      if (gameFilter !== "all" && gameOf(p) !== gameFilter) return;
      var hay = p.n.toLowerCase();
      if (terms.length && !terms.every(function (t) { return hay.indexOf(t) !== -1; })) return;
      var o = document.createElement("option");
      o.value = String(i);
      o.textContent = p.n;
      // paused items stay VISIBLE but unpickable — hiding them would read as "they
      // don't know this product, I'll just type it in as a custom item"
      if (pausedHit(p.n, p.s)) {
        o.disabled = true;
        o.textContent = p.n + " — ⏸ " + tr("not taking right now");
      }
      select.appendChild(o);
      shown++;
    });
    var custom = document.createElement("option");
    custom.value = "custom";
    custom.textContent = shown ? tr("Something else (type it in)") : tr("No match — add it manually");
    select.appendChild(custom);
  }
  renderGameChips();
  renderOptions("");
  if (searchInput) {
    searchInput.addEventListener("input", function () { renderOptions(this.value); syncLookup(); });
  }

  // optional: LIVE prices straight from the GG Hobby POS.
  // Set window.GG_PRICE_API to a JSON endpoint (CORS-enabled) returning either
  //   [{ "name": "...", "sku": "...", "upc": "...", "price": 176.17 }, ...]  or  { "sku-upc-or-name": 176.17, ... }
  // Prices update in place, so the estimator always shows your current numbers — and products
  // the POS pushes that aren't in the baked catalog yet get APPENDED, so a brand-new release
  // added to the POS shows up here live, no theme redeploy needed.
  if (window.GG_PRICE_API) {
    fetch(window.GG_PRICE_API)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        var map = {};        // key -> feed row (so we can tell which rows matched nothing)
        var feedRows = null;
        if (Array.isArray(data)) {
          feedRows = data;
          data.forEach(function (it) {
            var p = parseFloat(it.price != null ? it.price : (it.market != null ? it.market : it.tcg));
            if (!p) return;
            it._price = p;
            [it.name, it.sku, it.upc].forEach(function (k) {
              if (!k) return;
              var kk = String(k).toLowerCase().trim();
              if (!map[kk]) map[kk] = it;
            });
          });
        } else {
          Object.keys(data).forEach(function (k) {
            map[k.toLowerCase().trim()] = { _price: parseFloat(data[k]) };
          });
        }
        catalog.forEach(function (p) {
          // match on SKU or UPC first (reliable), then fall back to product name
          var m = (p.s && map[String(p.s).toLowerCase().trim()]) ||
                  (p.u && map[String(p.u).toLowerCase().trim()]) ||
                  map[p.n.toLowerCase().trim()];
          if (m && m._price) { p.mp = m._price; m._used = true; }
        });
        // anything the POS pushed that the baked catalog doesn't know = a new product
        if (feedRows) {
          var have = {};
          catalog.forEach(function (p) { have[p.n.toLowerCase().trim()] = true; });
          var added = 0;
          feedRows.forEach(function (it) {
            if (it._used || !it.name || !it._price) return;
            var nm = String(it.name).trim().slice(0, 120);
            var ct = String(it.category || it.type || "").trim();
            // the feed's game column ("onepiece") decides which no-buy list applies
            var isOp = (it.game && /one ?piece/i.test(String(it.game))) || OP_NAME.test(nm);
            if (!nm || have[nm.toLowerCase()] || isNoBuy(nm, ct, isOp ? "op" : null)) return;
            catalog.push({ n: nm, t: ct || catOf(nm), g: isOp ? "op" : null,
                           s: it.sku || null, u: it.upc || null, mp: it._price });
            have[nm.toLowerCase()] = true;
            added++;
          });
          if (added) {
            catalog.sort(function (a, b) { return a.n.localeCompare(b.n); });
            renderOptions(searchInput ? searchInput.value : "");
            syncLookup();
          }
        }
      })
      .catch(function () { /* live prices are best-effort; static prices still apply */ });
  }

  /* ---- live "not taking right now" list (Worker /api/nobuy) ----
     Pushed from the GG Hobby program whenever the shop pauses items. Renders a strip
     above the search box, disables those products in the dropdown, blocks custom adds
     and CSV rows, and appends a live line to the "What won't you take?" FAQ item.
     The FAQ's static paragraph is untouched — it must keep matching the FAQPage
     JSON-LD in <head> verbatim (Google requirement); the live line is a separate,
     clearly-temporary sibling element. */
  var NOBUY_API = window.GG_NOBUY_API ||
    (window.GG_PRICE_API ? String(window.GG_PRICE_API).replace(/\/api\/prices\/?$/, "/api/nobuy") : "") ||
    (window.GG_BOOK_API ? String(window.GG_BOOK_API).replace(/\/api\/book\/?$/, "/api/nobuy") : "");
  var pausedStrip = null;
  function renderPausedStrip() {
    if (!paused.length) { if (pausedStrip) pausedStrip.remove(); pausedStrip = null; return; }
    if (!pausedStrip) {
      // COLLAPSED by default (operator, Aug 27): the list can run dozens of items and a
      // wall of ⏸ names above the search read as clutter. One bold summary line carries
      // the count; tapping it opens the full list as chips. Contrast also bumped — the
      // old .08-alpha wash was barely visible.
      pausedStrip = document.createElement("details");
      pausedStrip.id = "estPaused";
      pausedStrip.style.cssText = "margin:0 0 14px;padding:10px 16px;border:1px solid rgba(234,179,8,.6);" +
        "background:rgba(234,179,8,.16);border-radius:12px;font-size:14px;line-height:1.6";
      var add = box.querySelector(".estimator__add");
      if (add && add.parentNode) add.parentNode.insertBefore(pausedStrip, add);
      else box.insertBefore(pausedStrip, box.firstChild);
    }
    var wasOpen = pausedStrip.open;
    pausedStrip.innerHTML = "";
    pausedStrip.open = wasOpen; // a live re-render must not slam the list shut mid-read
    var sum = document.createElement("summary");
    sum.style.cssText = "cursor:pointer;font-weight:700";
    sum.textContent = paused.length === 1
      ? tr("⏸ 1 item we're not taking right now — tap to see it")
      : tr("⏸ {n} items we're not taking right now — tap to see the list").replace("{n}", String(paused.length));
    var listEl = document.createElement("div");
    listEl.style.cssText = "display:flex;flex-wrap:wrap;gap:6px;margin-top:10px";
    paused.forEach(function (x) {
      var chip = document.createElement("span");
      chip.style.cssText = "border:1px solid rgba(234,179,8,.45);border-radius:999px;padding:2px 10px;font-size:12.5px";
      chip.textContent = x.label;
      listEl.appendChild(chip);
    });
    var tail = document.createElement("div");
    tail.style.cssText = "color:var(--muted);margin-top:8px;font-size:12.5px";
    tail.textContent = (pausedNote ? pausedNote + " — " : "") +
      tr("These may come back — everything else in the search below is fair game.");
    pausedStrip.appendChild(sum); pausedStrip.appendChild(listEl); pausedStrip.appendChild(tail);
  }
  function renderPausedFaq() {
    var sums = document.querySelectorAll(".faq__item summary");
    for (var i = 0; i < sums.length; i++) {
      if (!/won'?t you take|no acept/i.test(sums[i].textContent)) continue;
      var det = sums[i].parentNode;
      var p = det.querySelector("[data-nobuy-live]");
      if (!paused.length) { if (p) p.remove(); return; }
      if (!p) {
        p = document.createElement("p");
        p.setAttribute("data-nobuy-live", "");
        det.appendChild(p);
      }
      p.innerHTML = "";
      var lbl = document.createElement("strong");
      lbl.textContent = "⏸ ";
      p.appendChild(lbl);
      p.appendChild(document.createTextNode(
        tr("Also paused right now (these may come back): {list}")
          .replace("{list}", paused.map(function (x) { return x.label; }).join(", "))));
      return;
    }
  }
  if (NOBUY_API && NOBUY_API.indexOf("/api/nobuy") !== -1) {
    fetch(NOBUY_API)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !Array.isArray(data.items)) return;
        paused = data.items.filter(function (x) { return x && x.label; });
        pausedNote = String(data.note || "");
        renderPausedStrip();
        renderPausedFaq();
        renderOptions(searchInput ? searchInput.value : "");
      })
      .catch(function () { /* best-effort — an unreachable list never blocks the page */ });
  }

  function tcgLink(name, isOp) {
    return "https://www.tcgplayer.com/search/" + (isOp ? "one-piece-card-game" : "pokemon") + "/product?q=" + encodeURIComponent(name);
  }

  function money(n) {
    return "$" + n.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function rowQty(r) { return Math.max(1, parseInt(r.qtyInput.value, 10) || 1); }

  function recalc() {
    var marketTotal = 0, payTotal = 0, missing = 0;
    rows.forEach(function (r) {
      if (!r.market) { missing++; if (r.payEl) r.payEl.textContent = ""; return; }
      var line = r.market * rowQty(r);
      marketTotal += line;
      payTotal += line * r.rate;
      if (r.payEl) r.payEl.textContent = "→ " + money(line * r.rate);   // what GG pays for this line
    });
    if (marketFigure) marketFigure.textContent = money(marketTotal);
    if (marketTotal > 0) {
      figure.textContent = tr("up to {amt}").replace("{amt}", money(payTotal));
      bookBtn.disabled = false;
    } else {
      figure.textContent = tr("up to {amt}").replace("{amt}", "$0");
      bookBtn.disabled = rows.length === 0;
    }
    figure.dataset.missing = missing;
  }

  function addRow(name, qty, marketPrice, rate, product) {
    var li = document.createElement("li");
    li.className = "est-row";
    var nm = document.createElement("span");
    nm.className = "est-row__name";
    nm.textContent = name;
    nm.title = name;
    // QUANTITY is the customer's field; the PRICE is ours (auto-loaded market, display-only)
    var q = document.createElement("input");
    q.type = "number";
    q.min = "1";
    q.value = String(qty);
    q.className = "est-row__qtyin";
    q.setAttribute("aria-label", tr("Quantity of {name}").replace("{name}", name));
    q.addEventListener("input", recalc);
    var mkt = document.createElement("span");
    mkt.className = "est-row__mkt";
    mkt.textContent = marketPrice ? tr("{amt} mkt").replace("{amt}", money(marketPrice)) : tr("market TBD");
    var x = document.createElement("button");
    x.type = "button";
    x.className = "est-row__x";
    x.setAttribute("aria-label", tr("Remove {name}").replace("{name}", name));
    x.textContent = "×";
    var pay = document.createElement("span");
    pay.className = "est-row__pay";
    li.appendChild(nm); li.appendChild(q); li.appendChild(mkt); li.appendChild(pay); li.appendChild(x);
    list.appendChild(li);
    var row = { name: name, qtyInput: q, market: marketPrice || null, payEl: pay, rate: rate || 0.85, el: li,
                sku: (product && product.s) || null, upc: (product && product.u) || null,
                tcgId: (product && product.p) || null };
    rows.push(row);
    x.addEventListener("click", function () {
      rows = rows.filter(function (r) { return r !== row; });
      li.remove();
      recalc();
    });
    recalc();
  }

  // add a catalog product, or bump its quantity if it's already on the list
  function addOrBump(name, qty, mp, rate, product) {
    var existing = null;
    for (var i = 0; i < rows.length; i++) { if (rows[i].name === name) { existing = rows[i]; break; } }
    if (existing) {
      existing.qtyInput.value = String(rowQty(existing) + qty);
      existing.el.classList.remove("est-row--bump");
      void existing.el.offsetWidth;                 // restart the pulse
      existing.el.classList.add("est-row--bump");
      recalc();
    } else {
      addRow(name, qty, mp, rate, product);
    }
  }

  addBtn.addEventListener("click", function () {
    var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    var name, mp = null, rate = 0.85, product = null;
    if (select.value === "custom") {
      name = prompt(tr("What are you selling? (sealed Pokémon / One Piece only)"));
      if (!name) return;
      name = name.trim().slice(0, 80);
      if (!name) return;
      if (isNoBuy(name, "")) {
        alert(tr("Heads up — we don't buy booster boxes, Pokémon blisters or loose packs, Halloween/trick-or-treat packs, or Prismatic Evolutions booster bundles. (One Piece single packs & blisters are OK.)"));
        return;
      }
      var pzc = pausedHit(name, "");
      if (pzc) {
        alert(tr("Heads up — we're not taking {item} right now. It may come back — check the note above the search box.").replace("{item}", pzc.label));
        return;
      }
    } else {
      var p = catalog[parseInt(select.value, 10)];
      if (!p) return;
      // belt & braces: the option is disabled, but a stale selection can still linger
      var pz = pausedHit(p.n, p.s);
      if (pz) {
        alert(tr("Heads up — we're not taking {item} right now. It may come back — check the note above the search box.").replace("{item}", pz.label));
        return;
      }
      name = p.n;
      mp = p.mp || null;
      rate = rateOf(p);
      product = p;
    }
    addOrBump(name, qty, mp, rate, product);
    qtyInput.value = "1";
  });

  /* ---- TCGplayer CSV import ----
     Accepts both TCGplayer export shapes: the app's collection export (Name / Set / Quantity /
     Product ID / Card Number / Condition) and the seller portal's inventory export (Product
     Name / Set Name / TCGplayer Id / Total Quantity / Condition). Parsed entirely in the
     browser — the file is never uploaded. Sealed rows are matched against the catalog by
     TCGplayer productId first, then order-independent name tokens; single cards are counted
     and skipped (this estimator covers sealed product only). */
  var importBtn = document.getElementById("estImport");
  var importFile = document.getElementById("estImportFile");
  var importReport = document.getElementById("estImportReport");
  if (importBtn && importFile && importReport) {

    var STOP_TOKENS = { "pokemon": 1, "the": 1, "tcg": 1, "and": 1 };
    function normTokens(s) {
      s = String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
      s = s.replace(/\betb\b/g, "elite trainer box").replace(/\bbb\b/g, "booster bundle");
      s = s.replace(/[^a-z0-9& ]/g, " ").replace(/\s+/g, " ").trim();
      return s.split(" ").filter(function (t) { return t && !STOP_TOKENS[t]; });
    }
    function tokKey(s) { return normTokens(s).sort().join(" "); }

    function parseCsv(text) {
      var out = [], row = [], cur = "", inQ = false;
      for (var i = 0; i < text.length; i++) {
        var ch = text[i];
        if (inQ) {
          if (ch === '"') { if (text[i + 1] === '"') { cur += '"'; i++; } else { inQ = false; } }
          else { cur += ch; }
        } else if (ch === '"') { inQ = true; }
        else if (ch === ',') { row.push(cur); cur = ""; }
        else if (ch === '\n' || ch === '\r') {
          if (ch === '\r' && text[i + 1] === '\n') i++;
          row.push(cur); cur = "";
          if (row.length > 1 || row[0].trim() !== "") out.push(row);
          row = [];
          if (out.length > 50000) break;            // runaway-file guard
        } else { cur += ch; }
      }
      if (cur.trim() !== "" || row.length) { row.push(cur); out.push(row); }
      return out;
    }

    function colIndex(headers, names) {
      for (var i = 0; i < names.length; i++) {
        var j = headers.indexOf(names[i]);
        if (j !== -1) return j;
      }
      return -1;
    }
    function cell(r, idx) { return idx >= 0 && r[idx] != null ? String(r[idx]).trim() : ""; }

    function runImport(text) {
      var table = parseCsv(text);
      if (table.length < 2) return { error: true };
      var headers = table[0].map(function (hh) { return hh.toLowerCase().replace(/^\uFEFF/, "").trim(); });
      var cName = colIndex(headers, ["product name", "simple name", "name", "title", "product"]);
      if (cName === -1) return { error: true };
      var cQty  = colIndex(headers, ["total quantity", "quantity", "add to quantity", "qty", "count"]);
      var cSet  = colIndex(headers, ["set name", "set", "group name", "group"]);
      var cId   = colIndex(headers, ["tcgplayer id", "product id", "productid", "tcgplayer_id", "product_id"]);
      var cNum  = colIndex(headers, ["card number", "number", "card no"]);
      var cCond = colIndex(headers, ["condition"]);
      var cLine = colIndex(headers, ["product line", "game"]);

      // catalog indexes, built fresh so live-feed additions are included
      var byId = {}, byTok = {}, tokSets = [];
      catalog.forEach(function (p) {
        if (p.p != null) byId[String(p.p)] = p;
        var tk = tokKey(p.n);
        if (tk && !byTok[tk]) byTok[tk] = p;
        tokSets.push({ p: p, toks: normTokens(p.n) });
      });
      // catalog item whose full name is contained in the row's words — wordier row, same product
      function subsetMatch(words) {
        var best = null, bestLen = 0, tie = false;
        var set = {};
        words.forEach(function (t) { set[t] = 1; });
        tokSets.forEach(function (e) {
          if (e.toks.length < 3 || e.toks.length < bestLen) return;
          for (var i = 0; i < e.toks.length; i++) { if (!set[e.toks[i]]) return; }
          if (e.toks.length === bestLen && best && e.p !== best) { tie = true; return; }
          best = e.p; bestLen = e.toks.length; tie = false;
        });
        return tie ? null : best;                   // ambiguous match = no match (stay honest)
      }

      var added = 0, cards = 0, noBuy = 0, otherGame = 0, pausedN = 0, unmatched = [];
      for (var i = 1; i < table.length; i++) {
        var r = table[i];
        var nameV = cell(r, cName);
        if (!nameV) continue;
        var lineV = cell(r, cLine).toLowerCase();
        if (lineV && !/pok|one piece/.test(lineV)) { otherGame++; continue; }
        var numV = cell(r, cNum);
        var condV = cell(r, cCond);
        // a card number, or a card-grade condition, marks a single card (sealed is "Unopened")
        if (numV || (condV && !/unopened|sealed/i.test(condV))) { cards++; continue; }
        var qty = parseInt(cell(r, cQty).replace(/[^0-9]/g, ""), 10);
        if (!qty || qty < 1) qty = 1;
        var setV = cell(r, cSet);
        var idV = cell(r, cId).replace(/[^0-9]/g, "");
        var p = (idV && byId[idV]) ||
                byTok[tokKey(nameV)] ||
                (setV ? byTok[tokKey(setV + " " + nameV)] : null) ||
                subsetMatch(normTokens(setV ? setV + " " + nameV : nameV));
        if (!p) {
          if (isNoBuy(nameV, "")) { noBuy++; }
          else if (pausedHit(nameV, "")) { pausedN++; }
          else if (unmatched.length < 40) { unmatched.push(setV && nameV.toLowerCase().indexOf(setV.toLowerCase()) === -1 ? setV + " " + nameV : nameV); }
          continue;
        }
        if (pausedHit(p.n, p.s)) { pausedN++; continue; }
        addOrBump(p.n, qty, p.mp || null, rateOf(p), p);
        added++;
      }
      return { added: added, cards: cards, noBuy: noBuy, otherGame: otherGame, paused: pausedN, unmatched: unmatched };
    }

    function showReport(res) {
      importReport.innerHTML = "";
      importReport.hidden = false;
      importReport.className = "estimator__import-report" + (res.error || !res.added ? " estimator__import-report--warn" : "");
      function para(txt, cls) {
        var el = document.createElement("p");
        if (cls) el.className = cls;
        el.textContent = txt;
        importReport.appendChild(el);
      }
      if (res.error) {
        para(tr("Couldn't read that file — export the CSV from the TCGplayer app or seller portal and try again."));
        return;
      }
      para(res.added
        ? tr("Imported {n} sealed items from your TCGplayer file — they're on your list below.").replace("{n}", String(res.added))
        : tr("No sealed items in that file matched our catalog."));
      var skips = [];
      if (res.cards) skips.push(tr("{n} single cards skipped — this estimator covers sealed product only").replace("{n}", String(res.cards)));
      if (res.noBuy) skips.push(tr("{n} items we don't buy (booster boxes, Pokémon blisters, etc.)").replace("{n}", String(res.noBuy)));
      if (res.paused) skips.push(tr("{n} items we're not taking right now").replace("{n}", String(res.paused)));
      if (res.otherGame) skips.push(tr("{n} rows from other games").replace("{n}", String(res.otherGame)));
      if (skips.length) para(skips.join(" · "), "estimator__import-skips");
      if (res.unmatched.length) {
        var shown = res.unmatched.slice(0, 8).join(", ");
        var more = res.unmatched.length - 8;
        para(tr("Not matched: {list}{more} — if it's sealed, add it with the search above.")
          .replace("{list}", shown)
          .replace("{more}", more > 0 ? tr(" (+{n} more)").replace("{n}", String(more)) : ""), "estimator__import-miss");
      }
    }

    importBtn.addEventListener("click", function () { importFile.click(); });
    importFile.addEventListener("change", function () {
      var f = importFile.files && importFile.files[0];
      importFile.value = "";                        // allow re-importing the same file
      if (!f) return;
      if (f.size > 10 * 1024 * 1024) { showReport({ error: true }); return; }
      var reader = new FileReader();
      reader.onload = function () { showReport(runImport(String(reader.result || "").replace(/^\uFEFF/, ""))); };
      reader.onerror = function () { showReport({ error: true }); };
      reader.readAsText(f);
    });

    // \u2500\u2500 Collectr share-link lane (Aug 2026). The Worker fetches the public
    // showcase (browsers can't cross-origin) and returns {name, qty} lines;
    // we synthesize a two-column CSV and feed the SAME runImport pipeline \u2014
    // one matcher, one report, zero duplicated logic.
    var linkBtn = document.getElementById("estImportLink");
    var linkInput = document.getElementById("estImportLinkUrl");
    if (linkBtn && linkInput && window.GG_PRICE_API) {
      var pfUrl = String(window.GG_PRICE_API).replace(/\/api\/prices\/?$/, "/api/portfolio-fetch");
      linkBtn.addEventListener("click", function () {
        var url = (linkInput.value || "").trim();
        if (!/^https:\/\/(app\.|www\.)?getcollectr\.com\//i.test(url)) {
          alert(tr("That doesn't look like a Collectr share link \u2014 it starts with app.getcollectr.com."));
          return;
        }
        linkBtn.disabled = true;
        var was = linkBtn.textContent;
        linkBtn.textContent = tr("Importing\u2026");
        fetch(pfUrl, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ url: url }) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok || !res.j || !res.j.lines) { throw new Error((res.j && res.j.error) || "import failed"); }
            var csv = "Product Name,Quantity\n" + res.j.lines.map(function (l) {
              return '"' + String(l.name).replace(/"/g, '""') + '",' + (l.qty || 1);
            }).join("\n");
            showReport(runImport(csv));
            linkInput.value = "";
          })
          .catch(function (e) { alert(tr("Couldn't load that portfolio \u2014 ") + (e.message || "") ); })
          .then(function () { linkBtn.disabled = false; linkBtn.textContent = was; });
      });
    }
  }

  // stamp the price-data date into the note
  var dateEl = document.getElementById("estDate");
  if (dateEl && window.GG_PRICE_DATE) dateEl.textContent = window.GG_PRICE_DATE;

  // "check market price" helper link follows the dropdown selection
  var lookup = document.getElementById("estLookup");
  function syncLookup() {
    var p = catalog[parseInt(select.value, 10)];
    lookup.href = p ? tcgLink(p.n, gameOf(p) === "op")
                    : tcgLink(gameFilter === "op" ? "one piece sealed" : "pokemon sealed", gameFilter === "op");
  }
  select.addEventListener("change", syncLookup);
  syncLookup();

  // send the list into the booking form — human-readable text for the form, PLUS a structured
  // copy (name/qty/market/sku/upc/tcgId) that rides along with the booking so the shop's intake
  // system can prep the order before the seller arrives.
  bookBtn.addEventListener("click", function () {
    var items = document.getElementById("bItems");
    if (items) {
      items.value = rows.map(function (r) {
        return r.name + " ×" + rowQty(r) + (r.market ? " " + tr("(~${m} market ea.)").replace("{m}", r.market) : "") + (r.sku ? " [" + r.sku + "]" : "");
      }).join("\n");
    }
    window.GG_EST_ITEMS = rows.map(function (r) {
      return { name: r.name, qty: rowQty(r), market: r.market, rate: r.rate, sku: r.sku, upc: r.upc, tcgId: r.tcgId };
    });
    var book = document.getElementById("book");
    if (book) book.scrollIntoView({ behavior: "smooth" });
  });
})();
